"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchByPath = void 0;
exports.formatDate = formatDate;
exports.formatDateTime = formatDateTime;
exports.formatTime = formatTime;
exports.formatter = formatter;
exports.validateField = void 0;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
var validateField = function validateField(value, validations) {
  var _iterator = _createForOfIteratorHelper(validations),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var validation = _step.value;
      if (value === undefined || value === "" || value === null) {
        if (validation.type === "Required") {
          return {
            hasError: true,
            errorMessage: validation.validationMessage || "The value is required"
          };
        } else {
          return {
            hasError: false
          };
        }
      }
      var validationResult = checkValidation(value, validation);
      if (validationResult !== null && validationResult !== void 0 && validationResult.hasError) {
        return validationResult;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    hasError: false
  };
};
exports.validateField = validateField;
var checkValidation = function checkValidation(value, validation) {
  var _validation$numValues, _validation$strValues;
  if ((_validation$numValues = validation.numValues) !== null && _validation$numValues !== void 0 && _validation$numValues.length) {
    switch (validation.type) {
      case "LessThanChar":
        return {
          hasError: !(value.length <= validation.numValues[0]),
          errorMessage: validation.validationMessage || "The value must be shorter than ".concat(validation.numValues[0])
        };
      case "GreaterThanChar":
        return {
          hasError: !(value.length > validation.numValues[0]),
          errorMessage: validation.validationMessage || "The value must be longer than ".concat(validation.numValues[0])
        };
      case "LessThanNum":
        return {
          hasError: !(value < validation.numValues[0]),
          errorMessage: validation.validationMessage || "The value must be less than ".concat(validation.numValues[0])
        };
      case "GreaterThanNum":
        return {
          hasError: !(value > validation.numValues[0]),
          errorMessage: validation.validationMessage || "The value must be greater than ".concat(validation.numValues[0])
        };
      case "EqualTo":
        return {
          hasError: !validation.numValues.some(function (el) {
            return el === value;
          }),
          errorMessage: validation.validationMessage || "The value must be equal to ".concat(validation.numValues.join(" or "))
        };
      default:
    }
  } else if ((_validation$strValues = validation.strValues) !== null && _validation$strValues !== void 0 && _validation$strValues.length) {
    switch (validation.type) {
      case "StartWith":
        return {
          hasError: !validation.strValues.some(function (el) {
            return value.startsWith(el);
          }),
          errorMessage: validation.validationMessage || "The value must start with ".concat(validation.strValues.join(", "))
        };
      case "EndWith":
        return {
          hasError: !validation.strValues.some(function (el) {
            return value.endsWith(el);
          }),
          errorMessage: validation.validationMessage || "The value must end with ".concat(validation.strValues.join(", "))
        };
      case "Contains":
        return {
          hasError: !validation.strValues.some(function (el) {
            return value.includes(el);
          }),
          errorMessage: validation.validationMessage || "The value must contain ".concat(validation.strValues.join(", "))
        };
      case "NotContains":
        return {
          hasError: !validation.strValues.every(function (el) {
            return !value.includes(el);
          }),
          errorMessage: validation.validationMessage || "The value must not contain ".concat(validation.strValues.join(", "))
        };
      case "BeAfter":
        var afterTimeValue = parseInt(validation.strValues[0]);
        var afterTimeValidator = Number.isNaN(afterTimeValue) ? validation.strValues[0] : afterTimeValue;
        return {
          hasError: !(new Date(value) > new Date(afterTimeValidator)),
          errorMessage: validation.validationMessage || "The value must be after ".concat(validation.strValues[0])
        };
      case "BeBefore":
        var beforeTimeValue = parseInt(validation.strValues[0]);
        var beforeTimevalue = Number.isNaN(beforeTimeValue) ? validation.strValues[0] : beforeTimeValue;
        return {
          hasError: !(new Date(value) < new Date(beforeTimevalue)),
          errorMessage: validation.validationMessage || "The value must be before ".concat(validation.strValues[0])
        };
    }
  }
  switch (validation.type) {
    case "Email":
      var EMAIL_ADDRESS_REGEX = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
      return {
        hasError: !EMAIL_ADDRESS_REGEX.test(value),
        errorMessage: validation.validationMessage || "The value must be a valid email address"
      };
    case "JSON":
      var isInvalidJSON = false;
      try {
        JSON.parse(value);
      } catch (e) {
        isInvalidJSON = true;
      }
      return {
        hasError: isInvalidJSON,
        errorMessage: validation.validationMessage || "The value must be in a correct JSON format"
      };
    case "IpAddress":
      var IPV_4 = /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/;
      var IPV_6 = /^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$/;
      return {
        hasError: !(IPV_4.test(value) || IPV_6.test(value)),
        errorMessage: validation.validationMessage || "The value must be an IPv4 or IPv6 address"
      };
    case "URL":
      var isInvalidUrl = false;
      try {
        new URL(value);
      } catch (e) {
        isInvalidUrl = true;
      }
      return {
        hasError: isInvalidUrl,
        errorMessage: validation.validationMessage || "The value must be a valid URL that begins with a schema (i.e. http:// or mailto:)"
      };
    case "Phone":
      var PHONE = /^\+?\d[\d\s-]+$/;
      return {
        hasError: !PHONE.test(value),
        errorMessage: validation.validationMessage || "The value must be a valid phone number"
      };
    default:
  }
};
var monthToShortMon = {
  "1": "Jan",
  "2": "Feb",
  "3": "Mar",
  "4": "Apr",
  "5": "May",
  "6": "Jun",
  "7": "Jul",
  "8": "Aug",
  "9": "Sep",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec"
};
var invalidDateStr = "Invalid Date";
function formatDate(date, dateFormat) {
  if (date === undefined || date === null) {
    return date;
  }
  var validDate = new Date(Date.parse(date));
  if (validDate.toString() === invalidDateStr) {
    return date;
  }
  var splitDate = date.split(/-|\+|Z/);
  var year = splitDate[0];
  var month = splitDate[1];
  var day = splitDate[2];
  var truncatedMonth = month.replace(/^0+/, "");
  switch (dateFormat) {
    case "locale":
      return validDate.toLocaleDateString();
    case "YYYY.MM.DD":
      return "".concat(year, ".").concat(month, ".").concat(day);
    case "DD.MM.YYYY":
      return "".concat(day, ".").concat(month, ".").concat(year);
    case "MM/DD/YYYY":
      return "".concat(month, "/").concat(day, "/").concat(year);
    case "Mmm DD, YYYY":
      return "".concat(monthToShortMon[truncatedMonth], " ").concat(day, ", ").concat(year);
    default:
      return date;
  }
}
function formatTime(time, timeFormat) {
  if (time === undefined || time === null) {
    return time;
  }
  var splitTime = time.split(/:|Z/);
  if (splitTime.length < 3) {
    return time;
  }
  var validTime = new Date();
  validTime.setHours(Number.parseInt(splitTime[0], 10));
  validTime.setMinutes(Number.parseInt(splitTime[1], 10));
  var splitSeconds = splitTime[2].split(".");
  validTime.setSeconds(Number.parseInt(splitSeconds[0], 10), Number.parseInt(splitSeconds[1], 10));
  if (validTime.toString() === invalidDateStr) {
    return time;
  }
  switch (timeFormat) {
    case "locale":
      return validTime.toLocaleTimeString();
    case "hours24":
      return validTime.toLocaleTimeString("en-gb");
    case "hours12":
      return validTime.toLocaleTimeString("en-us");
    default:
      return time;
  }
}
function formatDateTime(dateTimeStr, dateTimeFormat) {
  if (dateTimeStr === undefined || dateTimeStr === null) {
    return dateTimeStr;
  }
  var dateTime = /^d+$/.test(dateTimeStr) ? new Date(Number.parseInt(dateTimeStr, 10)) : new Date(Date.parse(dateTimeStr));
  if (dateTime.toString() === invalidDateStr) {
    return dateTimeStr;
  }
  if (dateTimeFormat === "locale") {
    return dateTime.toLocaleString();
  }
  var dateAndTime = dateTime.toISOString().split("T");
  var date = formatDate(dateAndTime[0], dateTimeFormat.dateFormat);
  var time = formatTime(dateAndTime[1], dateTimeFormat.timeFormat);
  return "".concat(date, " - ").concat(time);
}
function formatter(value, formatterInput) {
  switch (formatterInput.type) {
    case "DateFormat":
      return formatDate(value, formatterInput.format);
    case "DateTimeFormat":
      return formatDateTime(value, formatterInput.format);
    case "TimeFormat":
      return formatTime(value, formatterInput.format);
    default:
      return value;
  }
}
var fetchByPath = function fetchByPath(input) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var accumlator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var currentPath = path.split(".");
  var head = currentPath.shift();
  if (input && head && input[head] !== undefined) {
    if (!currentPath.length) {
      accumlator.push(input[head]);
    } else {
      fetchByPath(input[head], currentPath.join("."), accumlator);
    }
  }
  return accumlator[0];
};
exports.fetchByPath = fetchByPath;